var _rect, _path, _path2, _g, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _g2, _ellipse3, _path7, _path8, _path9, _g3, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 303,
    viewBox: "0 0 304 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4404_149644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 304,
    height: 303
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 67.8499,
    width: 244.489,
    height: 244.489,
    transform: "rotate(-16 0.6875 67.8499)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4404_149644)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 215.376C305.573 202.533 273.29 151.091 160.963 183.3C79.8859 206.549 55.8377 263.128 70.7359 284.034",
    fill: "url(#paint0_radial_4404_149644)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4404_149644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 172,
    width: 238,
    height: 113
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.121 215.376C305.573 202.533 273.29 151.091 160.963 183.3C79.8859 206.549 55.8377 263.128 70.7359 284.034",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4404_149644)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 152.658,
    cy: 219.72,
    rx: 6.42639,
    ry: 3.56955,
    transform: "rotate(-16 152.658 219.72)",
    fill: "url(#paint1_linear_4404_149644)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.451707,
    cx: 220.963,
    cy: 209.061,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(-16 220.963 209.061)",
    fill: "url(#paint2_linear_4404_149644)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 99.1931,
    cy: 213.934,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(-16 99.1931 213.934)",
    fill: "url(#paint3_linear_4404_149644)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.716378,
    d: "M130.516 199.035C127.957 204.408 144.083 204.07 171.929 197.092C204.306 196.663 218.591 194.969 222.894 189.158C227.198 183.347 199.733 176.941 179.997 178.088C160.261 179.235 150.851 184.858 140.344 191.113C138.921 191.96 139.595 191.431 136.44 193.605C133.285 195.778 131.138 197.728 130.516 199.035Z",
    fill: "url(#paint4_linear_4404_149644)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.148 163.139C164.148 163.139 156.236 179.426 165.644 185.371C156.743 188.541 152.015 194.58 152.015 194.58L141.974 178.192L164.148 163.139Z",
    fill: "url(#paint5_linear_4404_149644)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 193.506C152.098 193.506 141.943 192.239 138.324 193.269C134.706 194.3 142.015 177.564 142.015 177.564L153.187 191.853L152.098 193.506Z",
    fill: "url(#paint6_linear_4404_149644)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2988 194.935C106.648 211.527 144.775 200.45 161.609 170.081C178.443 139.711 167.632 101.508 137.479 84.5626L76.2988 194.935Z",
    fill: "url(#paint7_linear_4404_149644)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.37,
    cy: 140.443,
    rx: 13.9447,
    ry: 63.0974,
    transform: "rotate(29 107.37 140.443)",
    fill: "url(#paint8_linear_4404_149644)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4404_149644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 84,
    width: 67,
    height: 113
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.37,
    cy: 140.443,
    rx: 13.9447,
    ry: 63.0974,
    transform: "rotate(29 107.37 140.443)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4404_149644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.942 139.292L97.962 134.498V134.498L114.505 156.376",
    fill: "url(#paint9_linear_4404_149644)"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.0219,
    cy: 133.172,
    rx: 9.01392,
    ry: 9.04518,
    transform: "rotate(-61 95.0219 133.172)",
    fill: "url(#paint10_linear_4404_149644)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5043 134.184C65.9289 134.063 66.252 133.767 66.4535 133.403C66.6886 132.979 66.7245 132.484 66.5581 131.996C64.9455 127.38 65.3889 122.279 67.7565 118.008C70.0906 113.797 74.1338 110.732 78.8425 109.62C79.7694 109.381 80.3675 108.445 80.1259 107.519C79.8843 106.593 78.9453 105.994 78.0185 106.232C72.3829 107.583 67.5216 111.265 64.7174 116.324C61.8796 121.443 61.3779 127.58 63.2793 133.109C63.6153 134.008 64.6046 134.517 65.5043 134.184ZM76.6862 134.324C77.0778 134.148 77.3896 133.889 77.5727 133.559C77.8058 133.138 77.8626 132.581 77.6432 132.066C76.6082 129.687 76.7112 127.074 77.91 124.911C79.0921 122.778 81.2046 121.319 83.707 120.899C84.6654 120.763 85.2947 119.855 85.0655 118.904C84.8684 117.97 83.8893 117.309 82.9142 117.476C79.3879 118.073 76.3912 120.143 74.7263 123.146C73.0114 126.24 72.8602 129.926 74.3185 133.286C74.7108 134.171 75.7577 134.634 76.6862 134.324Z",
    fill: "url(#paint11_linear_4404_149644)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2161 135.518C53.0155 135.88 52.6947 136.175 52.257 136.327C51.3518 136.614 50.4036 136.128 50.0736 135.235C47.404 127.013 48.2952 117.964 52.4918 110.394C54.6112 106.57 57.4265 103.302 60.7771 100.726C61.0294 100.487 63.4579 99.4042 64.1327 100.386C64.8075 101.367 62.81 103.546 62.81 103.546C59.8678 105.827 57.3926 108.709 55.5265 112.076C51.7981 118.802 51.0278 126.853 53.3974 134.199C53.4873 134.604 53.4335 135.126 53.2161 135.518Z",
    fill: "url(#paint12_linear_4404_149644)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4404_149644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 99,
    width: 17,
    height: 38
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2161 135.518C53.0155 135.88 52.6947 136.175 52.257 136.327C51.3518 136.614 50.4036 136.128 50.0736 135.235C47.404 127.013 48.2952 117.964 52.4918 110.394C54.6112 106.57 57.4265 103.302 60.7771 100.726C61.0294 100.487 63.4579 99.4042 64.1327 100.386C64.8075 101.367 62.81 103.546 62.81 103.546C59.8678 105.827 57.3926 108.709 55.5265 112.076C51.7981 118.802 51.0278 126.853 53.3974 134.199C53.4873 134.604 53.4335 135.126 53.2161 135.518Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4404_149644)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0285 91.8894C75.3873 91.5339 74.5793 91.7656 74.2238 92.4068L71.8643 96.6637L67.6081 94.3044C66.9668 93.949 66.1589 94.1807 65.8034 94.8219C65.4479 95.4632 65.6796 96.2712 66.3209 96.6266L70.577 98.9858L68.2169 103.244C67.8614 103.885 68.0931 104.693 68.7344 105.048C69.3756 105.404 70.1836 105.172 70.5391 104.531L72.8992 100.273L77.1578 102.634C77.799 102.989 78.607 102.757 78.9624 102.116C79.3179 101.475 79.0862 100.667 78.445 100.311L74.1864 97.9509L76.546 93.6941C76.9015 93.0528 76.6698 92.2448 76.0285 91.8894Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4404_149644",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.589 209.943) rotate(-106) scale(41.8404 436.981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4404_149644",
    x1: 147.486,
    y1: 218.774,
    x2: 149.444,
    y2: 222.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4404_149644",
    x1: 212.449,
    y1: 208.54,
    x2: 216.031,
    y2: 216.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4404_149644",
    x1: 92.728,
    y1: 214.025,
    x2: 94.7552,
    y2: 222.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4404_149644",
    x1: 317.701,
    y1: 157.851,
    x2: 295.961,
    y2: 95.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E1F0",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4404_149644",
    x1: 139.368,
    y1: 186.545,
    x2: 161.928,
    y2: 189.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4404_149644",
    x1: 145.051,
    y1: 198.903,
    x2: 153.289,
    y2: 186.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4404_149644",
    x1: 113.782,
    y1: 227.784,
    x2: 186.813,
    y2: 135.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4404_149644",
    x1: 101.029,
    y1: 40.3866,
    x2: 45.0483,
    y2: 61.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4404_149644",
    x1: 108.966,
    y1: 154.83,
    x2: 120.551,
    y2: 139.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4404_149644",
    x1: 82.6951,
    y1: 130.373,
    x2: 93.7455,
    y2: 144.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4404_149644",
    x1: 98.8937,
    y1: 91.4121,
    x2: 65.1654,
    y2: 85.0926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4404_149644",
    x1: 82.8495,
    y1: 79.6501,
    x2: 60.8176,
    y2: 72.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.2708f615459a4c8548e511afbd7c3f62.svg";
export { ForwardRef as ReactComponent };